import { makeStyles } from '@material-ui/core/styles'

const fontStack = 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif'

export const modernStyles = makeStyles(() => ({
    '@global': {
        'body, .ant-notification, .ant-message, .ant-select, .ant-picker': {
            fontFamily: fontStack,
        },
        body: {
            backgroundColor: '#f4f6fb',
            color: '#1f2937',
            WebkitFontSmoothing: 'antialiased',
        },

        '.m-sm-30': {
            maxWidth: 1600,
        },

        // Many list pages pass className="text-center" to CardHeader; keep headers left-aligned.
        '.MuiCardHeader-root.text-center': {
            textAlign: 'left',
            justifyContent: 'flex-start',
        },

        // Many list pages stripe rows with an inline #e6e8e6 background; soften it.
        '.MuiTableBody-root .MuiTableRow-root[style*="rgb(230, 232, 230)"]': {
            backgroundColor: '#f8fafc !important',
        },
        '.MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root': {
            borderBottom: 'none',
        },

        '.MuiTableContainer-root, .MuiCard-root .overflow-auto': {
            scrollbarWidth: 'thin',
        },

        '.MuiIconButton-root': {
            borderRadius: 8,
        },

        '.ant-notification-notice': {
            borderRadius: 10,
        },

        '::-webkit-scrollbar': {
            width: 8,
            height: 8,
        },
        '::-webkit-scrollbar-thumb': {
            backgroundColor: '#cbd5e1',
            borderRadius: 8,
        },
        '::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
        },
    },
}))
